
const allAdminRoles = [
  'Mahi.IsolationTags',
  'Mahi.NewConnections',
  'Mahi.User',
  'Mahi.UserAdmin',
  'Mahi.Vegetation',
  'Mahi.AssetData',
  'Mahi.RFI', // Request For Information
  'Mahi.DecommissionedLines',
  'Mahi.DecommissionedLines.Admin',
  'Mahi.DecommissionedLines.Inspector',
  'Mahi.DecommissionedLines.QA',
  'Mahi.Wairua'
]

export default allAdminRoles